import { render } from "./BalanceNiif.vue?vue&type=template&id=2007b81a&scoped=true"
import script from "./BalanceNiif.vue?vue&type=script&lang=js"
export * from "./BalanceNiif.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./BalanceNiif.vue?vue&type=style&index=1&id=2007b81a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007b81a"]])

export default __exports__